var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.transactionsRoutePrefix + ".index",
                          params: { id: _vm.id, wallet_id: _vm.wallet_id }
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "d-none d-lg-inline mr-2" }, [
                        _vm._v(
                          _vm._s(_vm.$t(_vm.transactionsRoutePrefix + ".title"))
                        )
                      ]),
                      _c("span", [_c("i", { staticClass: "fa fa-money-bill" })])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-text", {
                      attrs: {
                        options: { id: "name", label: "name", disabled: true }
                      },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = $$v
                        },
                        expression: "name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "balance",
                          label: "balance",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.balance,
                        callback: function($$v) {
                          _vm.balance = $$v
                        },
                        expression: "balance"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "currency_en_name",
                          transPrefix: _vm.walletTransPrefix + ".fields",
                          label: "currency.en_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.currency_en_name,
                        callback: function($$v) {
                          _vm.currency_en_name = $$v
                        },
                        expression: "currency_en_name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "currency_ar_name",
                          transPrefix: _vm.walletTransPrefix + ".fields",
                          label: "currency.ar_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.currency_ar_name,
                        callback: function($$v) {
                          _vm.currency_ar_name = $$v
                        },
                        expression: "currency_ar_name"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }